function CadastrarUsuarioTabela({ vetor, editar }) {
    // Mostrar log para ajudar a debugar quando a lista vier vazia ou em formato inesperado
    if (!Array.isArray(vetor)) console.warn('CadastrarUsuarioTabela: `vetor` não é um array', vetor);

    return (
        <div>
            <table className="table">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Status</th>
                        <th>Empresa</th>
                        <th>Perfil</th>
                        <th>Editar</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(vetor) && vetor.map((obj) => {
                        if (!obj) return null;

                        // Aceitar diferentes formatos: perfil pode estar em `perfil` ou `perfilId`,
                        // empresa pode estar em `idEmpresa` como objeto ou id.
                        const id = obj.id;
                        const name = obj.name || obj.nome || '';
                        const email = obj.email || '';
                        const phone = obj.phone || '';
                        const status = obj.status || '';

                        const empresa = obj.idEmpresa && typeof obj.idEmpresa === 'object' ? obj.idEmpresa.nome : (obj.idEmpresa?.nome || obj.idEmpresa || '');

                        const perfilObj = obj.perfil || obj.perfilId || obj.perfil_id || null;
                        const perfilNome = perfilObj && typeof perfilObj === 'object' ? (perfilObj.nome || perfilObj.name) : (perfilObj || '');

                        return (
                            <tr key={id}>
                                <td>{name}</td>
                                <td>{email}</td>
                                <td>{phone}</td>
                                <td>{status}</td>
                                <td>{empresa}</td>
                                <td>{perfilNome}</td>
                                <td>
                                    <button
                                        onClick={() => editar(id, obj.idEmpresa, perfilObj)}
                                        className='btn btn-success'>
                                        Editar
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default CadastrarUsuarioTabela;